export type NumberValueInput = number | string | null | undefined;

interface FormatNumberOptions {
  fractionDigits?: number;
}

function isEmptyValue(value: NumberValueInput) {
  return (
    value === null ||
    value === undefined ||
    (typeof value === 'number' && !Number.isFinite(value)) ||
    (typeof value === 'string' && value.trim() === '')
  );
}

function resolveNumber(value: NumberValueInput) {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }

  if (typeof value === 'string') {
    const numberValue = Number(value);

    return Number.isFinite(numberValue) ? numberValue : null;
  }

  return null;
}

function getUserLocale() {
  return typeof navigator === 'undefined' ? undefined : navigator.language;
}

export function formatNumber(
  value: NumberValueInput,
  { fractionDigits }: FormatNumberOptions = {}
) {
  if (isEmptyValue(value)) {
    return null;
  }

  const number = resolveNumber(value);

  if (number === null) {
    return null;
  }

  const precisionOptions =
    fractionDigits === undefined
      ? {}
      : {
          maximumFractionDigits: fractionDigits,
          minimumFractionDigits: fractionDigits,
        };

  return new Intl.NumberFormat(getUserLocale(), {
    ...precisionOptions,
  }).format(number);
}
